import { callFunction } from '@/lib/api';

// T1.7 speed-up: the patient tab shows the epikrise and bookingsvar panels side by
// side, and each called communicate-epikriser "list" (which syncs from
// Communicate). Both now ask for group "all", and a call already in flight for the
// same clinic and patient is shared, so the tab makes one call. Nothing is
// cached after the call returns, so a reload after attach still gets fresh rows.

type ListResult<T> = { epikriser: T[] };

const inFlight = new Map<string, Promise<ListResult<unknown>>>();

export function listReceivedMessages<T>(
  clinicId: string,
  patientId?: string,
  call: typeof callFunction = callFunction,
): Promise<ListResult<T>> {
  const key = `${clinicId}|${patientId ?? ''}`;
  const pending = inFlight.get(key);
  if (pending) return pending as Promise<ListResult<T>>;
  const request = call<Record<string, unknown>, ListResult<unknown>>('communicate-epikriser', {
    action: 'list',
    clinic_id: clinicId,
    group: 'all',
    ...(patientId ? { patient_id: patientId } : {}),
    nonce: Date.now(),
  }).finally(() => {
    inFlight.delete(key);
  });
  inFlight.set(key, request);
  return request as Promise<ListResult<T>>;
}
